import ScoreInput from "./scoreInputRow";
import TeamInfo from "./teamInfoRow";
import "./matchRow.sass";

/**
 * Componente que renderiza una fila de partido con equipos enfrentados
 * Muestra información de ambos equipos (logo y nombre) con inputs editables para marcadores
 * Integra datos reales del evento cuando están disponibles (fecha, hora, estadio)
 * 
 * @returns {JSX.Element} Fila de partido con equipos e inputs de marcador
*/
export default function MatchRow({ match, updateScore }) {
  // Solo es editable si el status es 'clarosports-next-game'
  // Bloqueado para: clarosports-finished-game y clarosports-in-progress-game
  const isInputDisabled = match.status !== 'clarosports-next-game';

  // Formatea la fecha y hora del partido
  const formatNextGameDate = (utcDate) => {
    if (!utcDate) return '';
    const date = new Date(utcDate);
    const localTime = date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
    const month = date.toLocaleDateString('es-ES', { month: 'short' }).slice(0, 3);
    const day = date.getDate();
    const year = date.getFullYear();
    return `${day} ${month} ${year} | ${localTime} hrs`;
  };

  return (
    <div className="match-row-container">
      <div className="match-row">
        {/* Equipo local - Lado izquierdo */}
        <div className="team-container team-home">
          <TeamInfo img={match.homeTeamImg} name={match.homeTeam} />
          <ScoreInput 
            value={match.homeGoals} 
            onChange={(e) => updateScore(match.id, 'home', e.target.value)} 
            disabled={isInputDisabled}
          />
        </div>

        <div className="vs-container">
          <div className="vs-separator">VS</div>
          {match.utc_date && (
            <div className="match-date-time">
              {formatNextGameDate(match.utc_date)}
            </div>
          )}
        </div>

        {/* Equipo visitante - Lado derecho */}
        <div className="team-container team-away">
          <ScoreInput 
            value={match.awayGoals} 
            onChange={(e) => updateScore(match.id, 'away', e.target.value)} 
            disabled={isInputDisabled}
          />
          <TeamInfo img={match.awayTeamImg} name={match.awayTeam} />
        </div>
      </div>
    </div>
  );
}